import * as React from 'react';
import { connect } from 'react-redux';
import { Page } from 'components/page-container';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { fetchPartners } from 'actions/partners';
import { IStore } from 'reducers/index';
import { HandleError } from 'components/handle-error';
import { InPageDialog } from 'damco-components';
import { IResponse } from 'reducers/bookings/models';
import { partnersCols } from 'constants/tableConstants';
import Table from 'components/data-table/Table';

interface IParams {
    targetId: number;
    target: number;
    isVisible: boolean
}
interface IMapDispatchToProps {
    fetchPartners: (type: number, valueId: any) => Promise<void>;
}
interface IMapStateToProps {
    isFetchDataLoading: boolean;
    isFetchDataError: boolean;
    pendingError: string | string[],
    partners: IResponse;
}

interface IProps extends IParams, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    page: number;
    pageSize: number;
    pendingError: string | string[];
    showDialog:boolean;
    type:string
}
export class _Partners extends React.Component<IProps, IState>{
    constructor(props: any) {
        super(props);
        this.state = {
            page: 1,
            pageSize: 10,
            pendingError: '',
            showDialog: false,
            type:'booking'
        };
    }
    public componentDidMount = () =>{
        this.props.fetchPartners(this.props.target, this.props.targetId)
    }
    public componentDidUpdate = (prevProps:any) => {
        if(this.props.target !== prevProps.target){
            let target:string = ''
            switch(this.props.target){
                case 1:
                    target = 'Booking'
                    break;
                case 2:
                    target = 'CBL'
                    break;
                case 3:
                    target = 'Equipment'
                    break;
                default:
                    target = 'FCR'
            }
            this.setState({type:target})
        }
        if(this.props.pendingError!== prevProps.pendingError){
            let checkText = this.props.pendingError
            if((Array.isArray(this.props.pendingError) && this.props.pendingError.length === 0)||
            this.props.pendingError === '')
            {
                checkText = 'Request Error'
            }
            this.setState({
                showDialog:true,
                pendingError: checkText
            })
        }
    }
    public render() {
        
        return (
            <React.Fragment>
                <Page>
                    <InPageDialog
                        showDialog={this.state.showDialog}
                        type={'error'}
                        message={this.props.pendingError}
                        closeMethod={() => this.setState({showDialog: false, pendingError: ''})} />
                    <HandleError
                        error={this.props.fetchPartners}
                    />
                    <div className="partnersTable">
                        <Table data={this.props.partners.result} 
                        id={`${this.state.type}-partners`}
                        cols={partnersCols} name={'partners-'} />
                    </div>
                </Page>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchDataLoading: state.partners.isFetchDataLoading,
    isFetchDataError: state.partners.isFetchDataError,
    pendingError: state.partners.pendingError,
    partners: state.partners.partners
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchPartners: (type: number, valueId: any) => dispatch(fetchPartners(type, valueId))
});

export const Partners = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_Partners);